import { CssBaseline, ThemeProvider } from '@mui/material';
import {
  ThemeProvider as StylesThemeProvider,
} from '@mui/styles';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { companySelectors } from '../../../state/ducks/company';
import theme from './generator';

const Theme: React.FC = ({ children }) => {
  const whiteLabeling = useSelector(companySelectors.getWhiteLabeling);

  return (
    <ThemeProvider theme={theme(whiteLabeling.colors)}>
      <StylesThemeProvider theme={theme(whiteLabeling.colors)}>
        <CssBaseline />
        {children}
      </StylesThemeProvider>
    </ThemeProvider>
  );
};

export default Theme;
